export default "__VITE_ASSET__DbX$LbFS__"